import { render, staticRenderFns } from "./VisitirArea.vue?vue&type=template&id=5dc84042&scoped=true&"
import script from "./VisitirArea.vue?vue&type=script&lang=js&"
export * from "./VisitirArea.vue?vue&type=script&lang=js&"
import style0 from "./VisitirArea.vue?vue&type=style&index=0&id=5dc84042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc84042",
  null
  
)

export default component.exports